import styles from './styles.module.scss'
import responsiveStyles from './responsive-styles.module.scss'

export function OperatorDisclosureBanner() {
    return (
        <div className={`${styles.banner} ${responsiveStyles.banner}`} role="note" aria-label="Operator disclosure">
            <div className={`${styles.inner} ${responsiveStyles.inner}`}>
                <p className={styles.text}>
                    This website is operated by <strong>Evans Hughes Ltd</strong> trading as Motor Finance Claims Advice.
                    Evans Hughes Ltd is authorised and regulated by the Financial Conduct Authority.
                </p>
            </div>
        </div>
    )
}
